import React from "react";
import { useNavigate } from "react-router-dom";

const cards = [
  {
    id: 1,
    title: "Cambridge",
    image:
      "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/cambridge-wide.webp", // Replace with your image
    description:
      "Immerse yourself in the academic excellence of the University of Cambridge, one of the world's leading institutions with a rich heritage of over 800 years. Explore a diverse range of subjects across arts, sciences, and technology, guided by world-class faculty. Experience cutting-edge research, vibrant student life, and a globally respected academic community. Cambridge offers a truly transformative education in a historic and inspiring environment."
      },
  {
    id: 2,
    title: "Oxford",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/oxford-wide.webp", // Replace with your image
    description:
      "Step into the historic legacy of the University of Oxford, the oldest English-speaking university in the world. Renowned for its rigorous academics and tutorial-based learning, Oxford offers an unmatched educational experience. With a global network of scholars and a vibrant college system, students thrive in both intellect and innovation. Discover tradition and modernity coexisting in perfect harmony.",
  },
  {
    id: 3,
    title: "London",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-London.webp", // Replace with your image
    description:
      "Study at the heart of one of the world's most dynamic and diverse cities. London is home to top-ranked institutions like Imperial College London, UCL, LSE, and King’s College London, offering exceptional programs in everything from science to social policy. The city itself becomes a classroom, filled with culture, history, and global opportunity. Learn, network, and grow in a truly international hub.",
  },
  {
    id: 4,
    title: "Sydney",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-Sydney.webp", // Replace with your image
    description:
      "Experience world-class education in Sydney, where top institutions like the University of Sydney and UNSW offer cutting-edge programs in a stunning coastal setting. Known for its academic excellence, innovation, and vibrant student culture, Sydney blends high-quality learning with outdoor living. Enjoy a global perspective in one of the most livable cities in the world.",
  },
  {
    id: 5,
    title: "New York",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-New-York.webp", // Replace with your image
    description:
      "Study in the city that never sleeps, home to elite universities like Columbia University and NYU. New York offers endless opportunities for learning, networking, and cultural enrichment. With its fast-paced energy and global influence, students here are at the crossroads of business, media, art, and academia. It's a launchpad for ambitious minds from every corner of the world.",
  },
  {
    id: 6,
    title: "Toronto",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-Toronto.webp", // Replace with your image
    description:
      "Toronto is a multicultural academic hub, hosting top institutions like the University of Toronto, consistently ranked among the best globally. The city offers a welcoming and inclusive environment, rich in innovation and research excellence. With strong connections to industries and global communities, Toronto is ideal for students seeking both academic and professional growth.",
  },
  {
    id: 7,
    title: "San Francisco",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-San-Francisco.webp", // Replace with your image
    description:
      "San Francisco is a global center of innovation, home to leading universities like Stanford and UC Berkeley in the nearby Bay Area. Known for its entrepreneurial spirit and tech-driven ecosystem, it's the perfect place for students passionate about startups, engineering, and social impact. A blend of natural beauty and academic brilliance, San Francisco sparks both intellect and creativity.",
  },
  {
    id: 8,
    title: "Tokyo",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/tokyo-home-1.webp", // Replace with your image
    description:
      "Explore the fusion of tradition and technology in Tokyo, home to prestigious universities such as the University of Tokyo and Waseda University. With a reputation for academic rigor and innovation, Tokyo offers a unique international learning experience. The city's vibrant culture, safety, and cutting-edge industries make it a top destination for students seeking excellence with an East Asian perspective.",
  },
];

const DestImpacts = () => {
  const navigate = useNavigate();
  return (
    <div className="container mx-auto py-10 px-4 md:px-10">
        <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-gray-800 text-center mt-5 mb-10 md:mb-14">Unleash Your Potential This Summer</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {cards.map((card, index) => (
          <>
            {/* Add hidden spacer div after the 5th card */}
            {index === 5 && (
              <div className="hidden lg:block col-span-1" aria-hidden="true" />
            )}
            
            <div
              key={card.id}
              className="relative group rounded-xl overflow-hidden shadow-lg"
            >
              {/* Background Image */}
              <img
                src={card.image}
                alt={card.title}
                className="w-full h-[500px] object-cover transform group-hover:scale-110 transition-transform duration-500"
              />

              {/* Static Title */}
              <div className="absolute top-4 left-4">
                <h3 className="text-3xl font-bold text-white  px-4 py-2 rounded-lg hover:text-white">
                  {card.title}
                </h3>
              </div>

            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-start p-6">
  {card.description && (
    <p className="text-white text-sm mt-12">{card.description}</p>
  )}
</div> 

              {/* Bottom Arrow Button */}
              <div
                className="absolute bottom-4 left-4 bg-white text-black rounded-full p-3
                  group-hover:scale-110 transition-transform duration-300"
                  onClick={() => {
                    navigate(`/eligibility`);
                  }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default DestImpacts;
